import { render, staticRenderFns } from "./sidebar-booker.vue?vue&type=template&id=a254d6d8"
import script from "./sidebar-booker.vue?vue&type=script&lang=js"
export * from "./sidebar-booker.vue?vue&type=script&lang=js"
import style0 from "./sidebar-booker.vue?vue&type=style&index=0&id=a254d6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports